export default "__VITE_ASSET__7bcCxZNF__"